import React, { Component } from 'react';
import LoginForm from './Auth/LoginForm';
import Logo from './Header/Logo';
import GDPRCompliance from './Auth/GDPRCompliance';
import { Drawer } from 'antd';
import { LOCAL_STORAGE_VAR } from '../constants/Common';
import { Link } from 'react-router-dom';
import LoginRightSection from './LoginRightSection';

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInfo: true,
      visible: false,
    };
  }

  componentDidMount() {
    let showInfo = JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_VAR}-cookie-policy`));
    if (showInfo) {
      this.setState({ showInfo: false });
    }
  }
  GDPRClick = () => {
    this.setState({
      visible: true,
    });
  };
  onClose = () => {
    this.setState({
      visible: false,
    });
  };
  setCookie = () => {
    localStorage.setItem(`${LOCAL_STORAGE_VAR}-cookie-policy`, true);
    this.setState({ showInfo: false });
  };
  render() {
    return (
      <div className="adma-login-wrap">
        <div className="adma-login-container">
          <div className="loginpage">
            <div className="adma-login-main-content">
              <div className="adma-app-login-content">
                <div className="adma-logo-content-bg">
                  <h1>
                    {/* <img src={require("../assets/img/login/logo.png")} /> */}
                    <Logo />
                  </h1>
                  <h2 className="login-title">
                    Sign In <span>to your account</span>
                  </h2>
                </div>

                <LoginForm history={this.props.history} />
                <Link className="textViewAll mt-10 cursor-pointer" to="/GDPR-compliance" target="_blank">
                  {/* onClick={this.GDPRClick} */}
                  This Site is GDPR compliance
                </Link>
              </div>
            </div>
            <LoginRightSection />
          </div>
        </div>
        <Drawer title={false} onClose={this.onClose} visible={this.state.visible} wrapClassName="diamondListinSidebar">
          <GDPRCompliance />
        </Drawer>
      </div>
    );
  }
}

export default SignIn;
